import * as React from "react";
import { BootstrapTable, BootstrapTableProps } from "react-bootstrap-table";
import { ButtonToolbar, ButtonGroup, Button, DropdownButton, MenuItem, InputGroup } from "react-bootstrap";
import { Utility } from "../../utils";

interface OwnProps {
    actionsCss?: string;
    actionsPrimary?: JSX.Element;
    actionsPrimaryCss?: string;
    actionsSecondary?: JSX.Element;
    actionsSecondaryCss?: string;
    appliedFilters?: JSX.Element;
    bsTable: BootstrapTableProps;
    changeLength?: boolean;
    lengthMenu?: number[];
    lengthMenuFormat?: (size: number) => string;
    search?: boolean;
    showPageInfo?: boolean;
    pageSize?: number;
    totalDataRows: number;
}

interface OwnState {
    page: number;
    pageSize?: number;
    search?: string;
    totalTableRows?: number;
}

export class BootstrapTableEnhanced extends React.Component<OwnProps, OwnState> {

    public static defaultProps: OwnProps = {
        actionsCss: "actions",
        actionsPrimaryCss: "actions-primary",
        actionsSecondaryCss: "actions-secondary",
        changeLength: true,
        bsTable: { data: [] },
        lengthMenu: [5, 10, 25, 100, -1],
        lengthMenuFormat: (size: number) => size === -1 ? "Show all" : `Show ${size} per page`,
        // pageSize: 10,
        search: true,
        showPageInfo: true,
        totalDataRows: 0,
    };

    public table: BootstrapTable | null = null;
    public page: number = 1;

    public constructor(props: any) {
        super(props);
        this.state = {
            page: 1,
            pageSize: 10,
        };

        this.handleAfterSearch = this.handleAfterSearch.bind(this);
        this.handleOnPageChange = this.handleOnPageChange.bind(this);
    }

    public componentWillReceiveProps(nextProps: Readonly<OwnProps>) {
        if (nextProps.pageSize && nextProps.pageSize !== this.state.pageSize) {
            console.log(nextProps.pageSize, this.state.pageSize);
            this.setState({
                ...this.state,
                pageSize: nextProps.pageSize,
            });
        }
    }

    public changePageSize(size: number) {
        const pageSize = size <= 0 ? undefined : size;
        this.setState({ ...this.state, pageSize });
    }

    public changePageNumber(page: number) {
        this.setState({ ...this.state, page });
    }

    public onSearch(search: string, result: ReadonlyArray<any>) {
        if (search !== this.state.search) {
            this.setState({
                ...this.state,
                page: 1,
                search: search === "" ? undefined : search,
                totalTableRows: search === "" || search === null ? undefined : result.length,
            });
        }
    }

    public handleAfterSearch(searchText: string, result: ReadonlyArray<any>) {
        this.onSearch(searchText, result);

        if (this.props.bsTable.options && this.props.bsTable.options.afterSearch)
            this.props.bsTable.options.afterSearch(searchText, result);
    }

    public handleOnPageChange(page: number, sizePerPage: number) {
        this.changePageNumber(page);

        if (this.props.bsTable.options && this.props.bsTable.options.onPageChange)
            this.props.bsTable.options.onPageChange(page, sizePerPage);
    }

    public render() {
        // total rows after filtering/searching/etc.
        const rows =  this.state.totalTableRows === undefined ? this.props.bsTable.data.length : this.state.totalTableRows;

        const defaultBsTableProps: BootstrapTableProps = {
            data: [],
            hover: true,
            options: {
                hideSizePerPage: true,
                nextPage: "Next",
                prePage: "Previous",
                firstPage: "First",
                lastPage: "Last",
                page: this.state.page,
                paginationSize: 4,
                // defaultSearch: "No", //this.state.search,
                sizePerPage: this.state.pageSize,
            },
            pagination: this.state.pageSize !== undefined && rows > this.state.pageSize,
        };

        // define bootstrap table props
        const bsTableProps = Utility.mergeObjects(defaultBsTableProps, this.props.bsTable);

        // override methods, but allow for custom implementations
        if (bsTableProps.options) {
            bsTableProps.options.onPageChange = this.handleOnPageChange;
            bsTableProps.options.afterSearch = this.handleAfterSearch;
        }

        // create page size dropdown
        let lengthMenu = null;
        if (this.props.changeLength && this.props.lengthMenu && this.props.lengthMenu.length) {
            const lengthFormatter = this.props.lengthMenuFormat || ((size: number) => size.toString());

            lengthMenu = this.props.lengthMenu.map((size, i) => {
                return <MenuItem key={i} onClick={() => this.changePageSize(size)}>{lengthFormatter(size)}</MenuItem>;
            });

            lengthMenu = <DropdownButton id="" title={lengthFormatter(this.state.pageSize || -1)} pullRight>{lengthMenu}</DropdownButton>;
        }

        // create page info text
        let pageInfo = null;
        if (this.props.showPageInfo) {
            const sp = Math.min(((this.state.page - 1) * (this.state.pageSize || rows)) + 1, rows);
            const ep = Math.min(this.state.page * (this.state.pageSize || rows), rows);
            const filtered = rows !== this.props.totalDataRows ? ` (filtered from ${this.props.totalDataRows} total entries)` : "";
            pageInfo = <div className="react-bs-table-enhanced-pageinfo btn-group">{`${sp} to ${ep} of ${rows}${filtered}`}</div>;
        }

        // create search component
        let search = null;
        if (this.props.search) {
            search = <ButtonGroup>
                <InputGroup>
                <input className="form-control" type="text" placeholder="Search..."
                    onChange={(e) => { if (this.table !== null) this.table.handleSearch(e.target.value); }}
                    value={this.state.search || ""}
                />
                </InputGroup>
                <Button onClick={() => { if (this.table !== null) this.table.handleSearch(""); }} ><i className="fa fa-times"></i></Button>
            </ButtonGroup>;
        }

        return <div className="react-bs-table-enhanced">
            <div id={this.props.actionsCss}>
                <div id={this.props.actionsPrimaryCss}>
                    {this.props.actionsPrimary}
                </div>
                <div id={this.props.actionsSecondaryCss}>
                    {this.props.actionsSecondary}
                    <ButtonToolbar className="react-bs-table-enhanced-info">
                        {pageInfo}
                        {search}
                        {lengthMenu}
                    </ButtonToolbar>
                </div>
            </div>

            {this.props.appliedFilters}

            <BootstrapTable {...bsTableProps} ref={(ref) => this.table = ref }>
                {this.props.children}
            </BootstrapTable>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/table/BootstrapTableEnhanced.tsx